/** A workspace bot's face: a white robot head on a disc of its accent colour.
 * Pure SVG so it stays crisp from a 20px chat gutter to the 72px detail header,
 * and needs no image upload or storage. The drawing is shared-ui's BotFace. */
import { cn } from '../../../shared/ui/utils';
import { useBotAppearance, type BotAppearance } from './botAppearance';
import { BotFace } from '../../../shared-ui/messages/BotFace';

export function BotAvatar({ appearance, size = 32, className, label }: {
  appearance: BotAppearance; size?: number; className?: string;
  /** Accessible name; omit when the bot's name is already next to it. */
  label?: string;
}) {
  // The face itself is shared with the native app; the span carries the web's sizing and clipping.
  return (
    <span className={cn('inline-flex shrink-0 overflow-hidden rounded-full', className)} style={{ width: size, height: size }}>
      <BotFace appearance={appearance} size={size} label={label} />
    </span>
  );
}

/** For chat rows, which know only the sender's user id. */
export function ChatBotAvatar({ botUserId, size, className, label }: { botUserId: string; size?: number; className?: string; label?: string }) {
  const appearance = useBotAppearance(botUserId);
  return appearance ? <BotAvatar appearance={appearance} size={size} className={className} label={label} /> : null;
}
